module.exports = __webpack_public_path__ + "img/0Q3A4612_L_Foamcore.d3b38c44.jpg";